import { __spreadArrays } from "tslib";
export var flattenCategories = function (cats) {
    return cats.reduce(function (p, c) {
        var children = c.children || [];
        var childrenFlats = children.reduce(function (sp, sc) {
            return __spreadArrays([{ id: sc.id, name: sc.name, parentName: c.name, parentId: c.id }], sp);
        }, []);
        return __spreadArrays(p, [{ id: c.id, name: c.name }], childrenFlats);
    }, []);
};
export var flattenLeafCategories = function (cats) {
    return cats.reduce(function (leafCats, parentCategory) {
        if (parentCategory.children && parentCategory.children.length) {
            return __spreadArrays(leafCats, parentCategory.children.map(function (childCategory) {
                return {
                    name: childCategory.name,
                    id: childCategory.id,
                    parentName: parentCategory.name,
                    parentId: parentCategory.id
                };
            }));
        }
        return __spreadArrays(leafCats, [{
                id: parentCategory.id,
                name: parentCategory.name
            }]);
    }, []);
};
//# sourceMappingURL=flatten-categories.js.map